export const testAttributes = {
    WRAPPER: 'spotlight-grid-wrapper',
    UNDER_GRID: 'spotlight-grid-under-grid',
}
export const defaults = {
    cardCount: 6,
    title: "Recommended for You"
}